import { makeStyles, Theme } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme: Theme) => ({
  downloadFile: {
    backgroundColor: "#F5F5F5",
    marginTop: "25px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
  },
  downloadBtn: {
    background: "transparent",
  },
  closeBtn: {
    marginRight: "0px",
    marginTop: "-5px",
    alignItems: "start",
    float: "right",
  },
  btn: {
    width: "219px",
    height: "54px",
    fontSize: "14px",
    border: "1px solid #000000",
    borderRadius: "27px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
  },
  tab: {
    "&.MuiButtonBase-root": {
      color: "#000000",
      padding: "20px 42px 18px 54px",
      boxShadow: "none",
      fontSize: "14px",
      textTransform: "capitalize",
    },
    "&.Mui-selected": {
      fontSize: "16px",
      fontWeight: 600,
    },
  },
  hsnTab: {
    "&.MuiButtonBase-root": {
      color: "#000000",
      padding: "20px 42px 18px 54px",
      margin: "0px 24px",
      boxShadow: "none",
      fontSize: "16px",
      textTransform: "capitalize",
    },
    "&.Mui-selected": {
      fontSize: "16px",
      fontWeight: 600,
    },
  },
  downloadGstSheetBtn: {
    borderRadius: 10,
    border: 0,
    width: 178,
    height: 39,
    backgroundColor: "#3D6AFD",
    color: "#ffffff",
    marginTop: 28,
  },
  uploadGstCatalogSheet: {
    height: 41,
    width: 112,
    border: 0,
    borderRadius: 10,
    marginTop: 26,
    backgroundColor: "#3D6AFD",
    fontWeight: 600,
    fontSize: 14,
    color: "#ffffff",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  linearProgressContainer: {
    width: 433,
    marginTop: 12,
    marginBottom: 16,
  },
  linearProgress: {
    backgroundColor: "#3D6AFD",
  },
  uploadAgainBtn: {
    width: 120,
    height: 41,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "#FFFFFF",
    border: "1px solid #E6E6EB",
    borderRadius: 8,
    color: "#3D6AFD",
    fontSize: 14,
    fontWeight: 600,
  },
  downloadErrorSheetBtn: {
    width: 147,
    height: 41,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "#3D6AFD",
    borderRadius: 10,
    border: 0,
    fontSize: 13,
    fontWeight: 600,
    color: "#FFFFFF",
    marginLeft: 12,
    textDecoration: "none",
  },
  okCloseBtn: {
    width: 96,
    height: 41,
    backgroundColor: "#FFF",
    border: "1px solid #E6E6EB",
    borderRadius: 8,
    fontWeight: 600,
    fontSize: 14,
    marginTop: 32,
  },
  indicator: {
    "&.MuiTabs-indicator": {
      backgroundColor: "#000000",
    },
  },
  line: {
    width: "107px",
    height: 0,
    borderTop: "1px solid #c4c4c4",
  },
  fileName: {
    width: "338px",
    height: " 43px",
    background: "#F7F7F7 0% 0% no-repeat padding-box",
    borderRadius: "22px",
  },
}));
